import { MessageCircle, Clock, TrendingUp } from "lucide-react";
import { waLink } from "@/lib/site";
import { track } from "@/lib/analytics";

export default function CTA() {
  return (
    <section
      data-testid="cta-section"
      className="relative py-20 sm:py-28 bg-[#0a2a17] text-white overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 30%, rgba(201,162,76,0.18), transparent 40%), radial-gradient(circle at 80% 70%, rgba(201,162,76,0.12), transparent 45%)",
        }}
      />

      <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <div className="inline-flex items-center gap-2 text-[#c9a24c] uppercase tracking-[0.3em] text-xs font-semibold">
          <Clock size={14} /> Atendimento imediato
        </div>

        <h2
          className="mt-5 text-3xl sm:text-4xl lg:text-6xl font-bold leading-[1.1]"
          style={{ fontFamily: "Playfair Display, serif" }}
        >
          Cada dia com o produto errado é{" "}
          <span className="text-[#c9a24c] italic">produção que escorre.</span>
        </h2>

        <p className="mt-6 text-white/80 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
          Chame nosso time no WhatsApp e receba a indicação técnica correta para
          o seu segmento — sem enrolação, sem espera. A gente responde e resolve.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            data-testid="cta-whatsapp-btn"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { source: "cta_section" })}
            className="inline-flex items-center justify-center gap-3 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white font-bold px-9 py-5 text-base sm:text-lg shadow-2xl transition-all hover:scale-[1.03]"
          >
            <MessageCircle size={20} strokeWidth={2.5} />
            Quero falar agora no WhatsApp
          </a>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
          {[
            { icon: Clock, k: "Resposta rápida", v: "Retorno em minutos, no horário comercial." },
            { icon: TrendingUp, k: "Indicação certa", v: "Time técnico indica o produto ideal para você." },
            { icon: MessageCircle, k: "Sem compromisso", v: "Tire dúvidas ou receba orçamento na hora." },
          ].map((b, i) => (
            <div
              key={i}
              className="rounded-2xl border border-white/10 bg-white/5 p-5 text-left"
            >
              <b.icon size={20} className="text-[#c9a24c]" strokeWidth={2.2} />
              <div className="mt-3 font-bold text-white">{b.k}</div>
              <div className="text-sm text-white/70 mt-1">{b.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
